import type { JSX as EmotionJSX } from 'react/jsx-runtime';

export enum WhiteLabelTabs {
  GENERAL = 'GENERAL',
  LOGIN_PAGE = 'LOGIN_PAGE',
  SEARCH_PANEL = 'SEARCH_PANEL',
  FILTERS = 'FILTERS',
  RESULT_TABLE = 'RESULT_TABLE',
  MAIN_PAGE = 'MAIN_PAGE',
}

export interface WhiteLabelTab {
  label: string;
  component: EmotionJSX.Element;
  value: WhiteLabelTabs;
}
